import {
    CONTACT_FORM_CREATE_REQUEST,
    CONTACT_FORM_CREATE_SUCCESS,
    CONTACT_FORM_CREATE_FAIL,
    CONTACT_FORM_LIST_REQUEST,
    CONTACT_FORM_LIST_SUCCESS,
    CONTACT_FORM_LIST_FAIL,
    CONTACT_FORM_DELETE_REQUEST,
    CONTACT_FORM_DELETE_SUCCESS,
    CONTACT_FORM_DELETE_FAIL,
    CONTACT_FORM_DELETE_ALL_REQUEST,
    CONTACT_FORM_DELETE_ALL_SUCCESS,
    CONTACT_FORM_DELETE_ALL_FAIL
} from '../actions/contactForm';

const initialState = {
    contactForms: [],
    loading: false,
    error: null,
    success: false
};

const contactFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONTACT_FORM_CREATE_REQUEST:
        case CONTACT_FORM_LIST_REQUEST:
        case CONTACT_FORM_DELETE_REQUEST:
        case CONTACT_FORM_DELETE_ALL_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false
            };

        case CONTACT_FORM_CREATE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                contactForms: [...state.contactForms, action.payload.contactForm]
            };

        case CONTACT_FORM_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                contactForms: action.payload
            };

        case CONTACT_FORM_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                contactForms: state.contactForms.filter(
                    (contactForm: { _id: string }) => contactForm._id !== action.payload
                )
            };

        case CONTACT_FORM_DELETE_ALL_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                contactForms: []
            };

        case CONTACT_FORM_CREATE_FAIL:
        case CONTACT_FORM_LIST_FAIL:
        case CONTACT_FORM_DELETE_FAIL:
        case CONTACT_FORM_DELETE_ALL_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        default:
            return state;
    }
};

export default contactFormReducer; 